import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import {
  CLUB_MEMBERSHIP_REQUESTING,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  GET_CLUB_MEMBERSHIP_SUCCESS
} from 'redux/clubMemberships/constants';
import { get as getOrder } from 'redux/orders/sagas';

import {
  editClubShipmentItems,
  editClubVirtualShipmentItems,
  getClubShipmentVirtualCart,
  getClubShipmentVirtualCartLimited,
  shipShipmentNow,
  skipClubShipment,
  unskipClubShipment
} from './api';
import {
  GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS,
  EDIT_CLUB_MEMBER_SHIPMENT_ITEMS_REQUEST,
  EDIT_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
  RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
  RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
  PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST,
  SKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST,
  GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR
} from './constants';

function* editItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      editClubShipmentItems,
      customerId(),
      action.clubMemberShipmentId,
      action.items
    );
    if (action.onSuccess) {
      yield call(getVirtualCart, {
        clubMemberShipmentId: action.clubMemberShipmentId
      });
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* resetVirtualItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    if (action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
      payload: { id: action.clubMemberShipmentId }
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* editVirtualItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      editClubVirtualShipmentItems,
      customerId(),
      action.clubMemberShipmentId,
      action.items
    );
    yield put({
      type: GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS,
      payload: response.data,
      clubMemberShipmentId: action.clubMemberShipmentId
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* shipNow(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      shipShipmentNow,
      customerId(),
      action.clubMemberShipmentId
    );
    yield call(getOrder, { orderId: response.data.orderId });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* skip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      skipClubShipment,
      customerId(),
      action.clubMemberShipmentId
    );
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* unskip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      unskipClubShipment,
      customerId(),
      action.clubMemberShipmentId
    );
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

export function* getVirtualCart(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    let response;
    if (!customerId()) {
      response = yield call(
        getClubShipmentVirtualCartLimited,
        action.clubMemberShipmentId
      );
    } else {
      response = yield call(
        getClubShipmentVirtualCart,
        customerId(),
        action.clubMemberShipmentId
      );
    }
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
      payload: response.data,
      clubMemberShipmentId: action.clubMemberShipmentId
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (err) {
    if ([404, 422, 429].includes(err.response.status)) {
      yield put({
        type: GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR,
        payload: { errorMessage: err.response.data.message },
        clubMemberShipmentId: action.clubMemberShipmentId
      });
    } else {
      if (action.onError) {
        action.onError();
      }
      yield call(addAPIError, err);
    }

    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
  }
}

function* watchList() {
  yield takeLatest(
    EDIT_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
    editVirtualItems
  );
  yield takeLatest(
    RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
    resetVirtualItems
  );
  yield takeLatest(EDIT_CLUB_MEMBER_SHIPMENT_ITEMS_REQUEST, editItems);
  yield takeLatest(PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST, shipNow);
  yield takeLatest(SKIP_CLUB_MEMBER_SHIPMENT_REQUEST, skip);
  yield takeLatest(UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST, unskip);
  yield takeEvery(
    GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST,
    getVirtualCart
  );
}

export default function* clubMembershipSagas() {
  yield all([watchList()]);
}
